/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry, Rachel Ralston
*/
import React, { useEffect, useRef } from 'react';
import Block from 'wfui-digital-core/es/Block';
import { blockScrolling, unblockScrolling, getClasses } from 'wfui-digital-core/es/lib';
import useWindowScrollPosition from 'wfui-digital-core/es/useWindowScrollPosition';
import useSettings from '../../../hooks/use-settings';
import styles from './NavigationMenuOverlay.less';
var SCROLL_DISTANCE = 150;

var NavigationMenuOverlay = function NavigationMenuOverlay(_ref) {
  var brand = _ref.brand,
      handleKeyDown = _ref.handleKeyDown,
      topChildWindowId = _ref.topChildWindowId,
      childWindowId = _ref.childWindowId,
      handleClick = _ref.handleClick,
      isClosing = _ref.isClosing,
      children = _ref.children;
  var overlayRef = useRef();

  var _useSettings = useSettings(),
      useTPBBimUpdates = _useSettings.useTPBBimUpdates;

  var _useWindowScrollPosit = useWindowScrollPosition(),
      scrollTop = _useWindowScrollPosit.y;

  useEffect(function () {
    var overlay = overlayRef.current;
    blockScrolling(overlay);
    return function () {
      unblockScrolling(overlay);
    };
  }, []);

  var onKeyDown = function onKeyDown(event) {
    if (childWindowId === topChildWindowId) {
      handleKeyDown(event);
    }
  };

  var classes = ['navigationMenuOverlay', isClosing && 'isClosing', useTPBBimUpdates && 'useTPBBimUpdates', scrollTop > SCROLL_DISTANCE && 'collapsed'];
  var classNames = getClasses({
    styles: styles,
    classes: classes,
    brand: brand
  });
  return /*#__PURE__*/React.createElement(Block, {
    className: classNames,
    onClick: handleClick,
    onKeyDown: onKeyDown,
    elementRef: overlayRef
  }, children);
};

export default NavigationMenuOverlay;